import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { OnestBoldBig, OnestNormalDefault } from "../../styled/TextComponents";
import { getGamePreviewUrl } from "./gamesUtils";
import {
  bannerDescriptionStyle,
  bannerImageStyle,
  bannerOverlayStyle,
  bannerTitleStyle,
  getBannerContainerStyle,
  getBannerPlayButtonStyle,
} from "./gamesStyles";
import { useI18n } from "../../../i18n/I18nProvider";

const FeaturedGameBanner = ({ game }) => {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);
  const [pressed, setPressed] = useState(false);
  const [btnHovered, setBtnHovered] = useState(false);
  const [btnPressed, setBtnPressed] = useState(false);

  if (!game) return null;

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => {
        setHovered(false);
        setPressed(false);
        setBtnHovered(false);
        setBtnPressed(false);
      }}
      onMouseDown={() => setPressed(true)}
      onMouseUp={() => setPressed(false)}
      onClick={() => {
        if (game.link) navigate(game.link);
      }}
      style={getBannerContainerStyle({ hovered, pressed })}
    >
      <img
        src={getGamePreviewUrl(game.image_path)}
        alt={t(game.name)}
        style={bannerImageStyle}
      />

      <div style={bannerOverlayStyle}>
        <OnestBoldBig style={bannerTitleStyle}>{t(game.name)}</OnestBoldBig>
        <OnestNormalDefault style={bannerDescriptionStyle}>
          {t(game.description)}
        </OnestNormalDefault>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            if (game.link) navigate(game.link);
          }}
          onMouseEnter={() => setBtnHovered(true)}
          onMouseLeave={() => {
            setBtnHovered(false);
            setBtnPressed(false);
          }}
          onMouseDown={() => setBtnPressed(true)}
          onMouseUp={() => setBtnPressed(false)}
          style={getBannerPlayButtonStyle({ btnHovered, btnPressed })}
        >
          {t("Играть")}
        </button>
      </div>
    </div>
  );
};

export default FeaturedGameBanner;
